import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=891b7f8c&scoped=true&"
import script from "./lesson.js?vue&type=script&lang=js&"
export * from "./lesson.js?vue&type=script&lang=js&"
import style0 from "./lesson.vue?vue&type=style&index=0&id=891b7f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891b7f8c",
  null
  
)

export default component.exports